import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';



function visualarts() {
  
  const tabs = [

    { title: 'Visual Arts', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>Visual Arts</h1>
      </div>
  
      <div className='photo-sec'>


        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-01.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-01.webp'></img>
          </Link>
        </div>
        
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-02.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-02.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-03.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-03.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-04.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-04.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-05.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-05.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-06.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-06.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-07.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-07.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-08.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-08.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-09.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-09.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-10.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-10.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-11.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-11.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-12.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-12.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-13.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-13.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-14.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-14.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-15.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-15.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-16.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-16.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-17.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-17.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-18.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-18.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-19.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-19.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-20.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-20.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-21.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-21.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-22.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-22.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-23.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-23.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-24.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-24.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-25.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-25.webp'></img>
          </Link>
        </div>

        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-26.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-26.webp'></img>
          </Link>
        </div>
       
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-27.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-27.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-28.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-28.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-29.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-29.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-30.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-30.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-31.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-31.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-32.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-32.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-33.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-33.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-34.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-34.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-35.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-35.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-36.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-36.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-37.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-37.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-38.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-38.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/2025/arts-exhibition-39.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/2025/arts-exhibition-39.webp'></img>
          </Link>
        </div>


        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition.webp'></img>
          </Link>
        </div>


        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_1.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_1.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_2.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_2.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_3.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_3.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_4.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_4.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_5.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_5.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_6.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_6.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_7.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_7.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_8.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_8.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_9.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_9.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_10.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_10.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_11.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_11.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_12.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_12.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_13.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_13.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_14.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_14.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_15.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_15.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_16.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_16.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_17.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_17.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
        <Link to="../img/Visual Arts/visual arts exhibition_18.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/visual arts exhibition_18.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
        <Link to="../img/Visual Arts/terracota studio practice.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/terracota studio practice.webp'></img>
          </Link>
        </div>
        
        <div className='photo-box'>
        <Link to="../img/Visual Arts/naman jain ibdp y2 hand casting.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/naman jain ibdp y2 hand casting.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
        <Link to="../img/Visual Arts/lino printing.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/lino printing.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
        <Link to="../img/Visual Arts/Graffiti art.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/Graffiti art.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
        <Link to="../img/Visual Arts/Exhibition pic.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/Exhibition pic.webp'></img>
          </Link>
        </div>
      
        <div className='photo-box'>
        <Link to="../img/Visual Arts/exhibition 1.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Visual Arts/exhibition 1.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/exhibition.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/exhibition.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Exhibition (2).webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Exhibition (2).webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/block suculpture.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/block suculpture.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/bhumika y1.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/bhumika y1.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art7.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art7.webp'></img>
          </Link>
        </div>
     
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art6.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art6.webp'></img>
          </Link>
        </div>
     
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art5.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art5.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art4.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art4.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art3.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art3.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art2.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art2.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Art1.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Art1.webp'></img>
          </Link>
        </div>
       
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Aman sharma y2 sculpture.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Aman sharma y2 sculpture.webp'></img>
          </Link>
        </div>
     
       
        <div className='photo-box'>
    <Link to="../img/Visual Arts/aman art.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/aman art.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 19.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 19.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 20.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 20.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 21.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 21.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 22.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 22.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 23.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 23.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 24.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 24.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 25.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 26.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 27.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 27.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 28.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 28.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 29.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 29.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 30.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 30.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 31.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 31.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 32.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 32.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 33.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 33.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 19.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 19.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 34.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 34.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 35.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 35.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 36.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 36.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 37.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 37.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 38.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 38.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 39.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 39.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 40.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 40.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 41.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 42.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 43.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 43.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 44.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 44.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 45.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 46.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 47.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 47.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 48.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 48.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 49.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 49.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 50.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 50.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 51.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 51.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 52.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 52.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 53.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 53.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 54.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 54.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 55.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 55.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 56.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 56.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 57.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 57.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 58.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 58.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 59.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 59.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 60.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 60.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 61.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 61.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 62.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 62.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 63.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 63.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 64.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 64.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 65.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 65.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 66.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 66.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 67.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 67.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 68.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 68.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 69.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 69.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 70.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 70.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 71.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 71.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 72.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 72.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 73.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 73.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 74.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 74.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 75.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 75.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 76.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 76.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 76.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 76.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 77.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 77.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 78.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 78.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 79.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 79.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 80.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 80.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 81.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 81.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 82.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 82.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 83.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 83.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 84.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 84.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 85.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 85.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 86.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 86.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 87.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 87.webp'></img>
          </Link>
        </div>
      
        <div className='photo-box'>
    <Link to="../img/Visual Arts/Visual Art 88.webp"
            target="_blank"
            rel="noopener noreferrer">
            <img src='../img/Visual Arts/Visual Art 88.webp'></img>
          </Link>
        </div>
     
   
       
  
        </div>
        </div>
    },

    

    



]
  return (
    <div>
    <div className='ibdp-hero-sec'>
       <img src='newimg/Screenshot_26.webp'/>

     </div>
     <div className="newsletter-sec">
     <HorizontalTabs tabs={tabs} />
     </div>


   </div> 
  )
}

export default visualarts
